// Replace default browser validations with Juul branded validations.
//
// 1. Prevent submit of invalid forms, plays nicely with [data-disable-with].
// 2. Replace default browser popups with "pop under" error messages.
// 3. Eager validation: validate on blur, on submit, and on input of dirty fields.
//
// Eg: <form data-validate-form>

import $ from 'jquery';
import debounce from 'lodash/debounce';
import notifyError from 'common/utils/notify';

const ERROR_MESSAGE =
  global.translations &&
  global.translations.messages['common.utils.alert.form_invalid'];

const initValidateForm = function() {
  $(this).attr('novalidate', true);
};

const internetExplorerLabels = function(el) {
  return $(`label[for='${el.id}']`)
    .add($(el).closest('label'))
    .toArray();
};

const onBlur = function() {
  validateField(this);
};

const onInput = function() {
  validateField(this, true);
};

const onSubmit = function(e) {
  if (this.checkValidity()) {
    return preventDisableWith(this);
  }
  e.preventDefault();
  notifyError(ERROR_MESSAGE);
  reEnableDisableWith(this);
  $('input', this).each((i, el) => validateField(el));
};

const preventDisableWith = function(parent) {
  $('[data-disable-with-disabled]', parent).each(function() {
    const old = $(this).attr('data-disable-with-disabled');
    if (old) $(this).attr('data-disable-with', old);
  });
};

const reEnableDisableWith = function(parent) {
  $('[data-disable-with]', parent).each(function() {
    const old = $(this).attr('data-disable-with');
    $(this).attr('data-disable-with-disabled', old);
    $(this).removeAttr('data-disable-with');
  });
};

const showValidation = function(input, target, soft) {
  const isValid = input.checkValidity();
  if (soft && !isValid) return;
  $(target)
    .toggleClass('invalid', !isValid)
    .next('.invalid-feedback')
    .remove();
  if (!isValid) {
    $('<div class="invalid-feedback">')
      .text(input.validationMessage)
      .insertAfter(target);
  }
};

const validateCheckbox = function(el, soft) {
  const target = (el.labels || internetExplorerLabels(el))[0];
  showValidation(el, target, soft);
};

const validateField = function(el, soft = false) {
  const validators = {
    checkbox: validateCheckbox,
    default: validateText,
  };
  const validator = validators[el.type] || validators['default'];
  validator(el, soft);
};

const validateText = function(el, soft) {
  showValidation(el, el, soft);
};

$(() => {
  if (!$('[data-validate-form]').length) return;
  $('body').on('blur', '[data-validate-form] input', onBlur);
  $('body').on('change input', '[data-validate-form] input', debounce(onInput));
  $('body').on('submit', '[data-validate-form]', onSubmit);
  $('[data-validate-form]').each(initValidateForm);
});
